exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dui-colorpicker-custom-panel{box-sizing:content-box!important}", ""]);

